// USES:
// gdc-peekaboo-svg-fixed.liquid

// NEEDS:
// ADD to any component to show peekaboo svg
//  {% if section.settings.show_peekaboo_svg %}
//     {% render 'gdc-peekaboo-svg-clone' %}
//   {% endif %}

// SCHEMA SETTING:
// {
//   "type": "checkbox",
//   "id": "show_peekaboo_svg",
//   "label": "Show peekaboo SVG",
//   "default": false,
//   "info": "Must have a fixed svg for peekaboo to work"
// },

// ADD [gdc-peekaboo-container] attribute to parent container that reveals clone

// ADD gdc-peekaboo-svg-fixed.liquid to theme.js in <main></main>

// IMPORTS TO liquid.js
// {{ 'gdc-peekaboo-svg.css' | asset_url | stylesheet_tag }}
// <script src="{{ 'gdc-peekaboo-svg.js' | asset_url }}" defer="defer"></script>
// <script src="{{ 'gdc-peekaboo-svg-clone.js' | asset_url }}" defer="defer"></script>

const fixedSVG = () => document.querySelector('[gdc-peekaboo-svg-fixed]')
const fixedSVGClones = () => document.querySelectorAll('[gdc-peekaboo-clone]')
const getPageScrollPosition = () => window.scrollY

function setSVGClonePosition() {
  if (fixedSVG() && fixedSVGClones()) {
    fixedSVGClones().forEach((clone) => {
      const cloneSVGParent = clone.closest('[gdc-peekaboo-container]')
      const { x: fixedSVGX, y: fixedSVGY } = fixedSVG().getBoundingClientRect()
      const { x: cloneSVGParentX, y: cloneSVGParentY } = cloneSVGParent.getBoundingClientRect()

      clone.style.top = `${fixedSVGY - getPageScrollPosition() - cloneSVGParentY}px`
      clone.style.left = `${fixedSVGX - cloneSVGParentX}px`
    })
  }
}

function handleClonesPositions() {
  const position = `translateY(${getPageScrollPosition()}px)`
  fixedSVGClones().forEach((clone) => {
    clone.style.transform = position
  })
}

function handleHideComma() {
  const comma = document.querySelector('.gdc-svg-fixed')

  if (comma) {
    if (atPageBottom()) {
      comma.classList.add('hide-fixed-svg')
    } else {
      comma.classList.remove('hide-fixed-svg')
    }
  }
}

window.addEventListener('scroll', handleHideComma)

if (fixedSVG() && fixedSVGClones()) {
  window.addEventListener('scroll', handleClonesPositions)
  window.addEventListener('load', setSVGClonePosition)
  window.addEventListener('resize', setSVGClonePosition)
}
